import type { FullReportType, StandardReportDetailData } from './types';

export const CHEMICAL_DETAIL = {
  reportId: 'RPT-CHEM-J4K5272',
  performedAt: '2024-11-14 10:22',
  lab: 'Severstal Mill Lab - Spectrometer 2',
  technician: 'A. Sokolov',
  spec: 'API 5L Sec. 9.2 / ISO 14284',
  sourceFile: 'MTC-J4K5272-chemical.pdf',
  sample: {
    id: 'HEAT-J4K-5272-A',
    type: 'ladle_analysis',
    takenAt: '2024-11-14 09:58',
    furnace: 'BOF-3',
    castNo: 'C-2024-5272',
  },
  elements: [
    { symbol: 'C', name: 'Carbon', value: 0.085, unit: '%', max: 0.16, status: 'PASS' },
    { symbol: 'Mn', name: 'Manganese', value: 1.42, unit: '%', max: 1.65, status: 'PASS' },
    { symbol: 'P', name: 'Phosphorus', value: 0.0094, unit: '%', max: 0.02, status: 'PASS', itpStricter: true, stdMax: 0.025 },
    { symbol: 'S', name: 'Sulfur', value: 0.0028, unit: '%', max: 0.01, status: 'PASS', itpStricter: true, stdMax: 0.015 },
    { symbol: 'Si', name: 'Silicon', value: 0.31, unit: '%', max: 0.45, status: 'PASS' },
    { symbol: 'V', name: 'Vanadium', value: 0.048, unit: '%', max: 0.10, status: 'PASS' },
    { symbol: 'Nb', name: 'Niobium', value: 0.042, unit: '%', max: 0.10, status: 'PASS' },
    { symbol: 'Ti', name: 'Titanium', value: 0.018, unit: '%', max: 0.06, status: 'PASS' },
    { symbol: 'Cu', name: 'Copper', value: 0.12, unit: '%', max: 0.50, status: 'PASS' },
    { symbol: 'Ni', name: 'Nickel', value: 0.18, unit: '%', max: 0.50, status: 'PASS' },
    { symbol: 'Cr', name: 'Chromium', value: 0.09, unit: '%', max: 0.50, status: 'PASS' },
    { symbol: 'Mo', name: 'Molybdenum', value: 0.04, unit: '%', max: 0.50, status: 'PASS' },
    { symbol: 'B', name: 'Boron', value: 0.0001, unit: '%', max: 0.0005, status: 'PASS' },
    { symbol: 'Al', name: 'Aluminum', value: 0.034, unit: '%', max: null, status: 'PASS', storeOnly: true },
  ],
  calculations: [
    { key: 'V_NB_TI', label: 'V + Nb + Ti sum', value: 0.108, max: 0.15, formula: 'V + Nb + Ti', status: 'PASS' },
    { key: 'CE_IIW', label: 'Carbon equivalent', value: 0.349, max: 0.42, formula: 'C + Mn/6 + (Cr+Mo+V)/5 + (Ni+Cu)/15', status: 'PASS' },
    { key: 'Pcm', label: 'Weld cracking idx', value: 0.198, max: 0.25, formula: 'C + Si/30 + (Mn+Cu+Cr)/20 + Ni/60 + Mo/15 + V/10 + 5B', status: 'PASS' },
  ],
  coverage: {
    heatNumber: 'J4K-5272',
    castDate: '2024-11-12',
    mill: 'Severstal Steelworks',
    pipesCovered: 86,
    pipeNo: '30858',
    highlightedIndex: 7,
    analysisType: 'Heat (ladle)',
    note: 'Product analysis not required by ITP',
  },
};

export const CVN_DETAIL = {
  reportId: 'RPT-CVN-2024-11-LOT238',
  performedAt: '2024-11-14 16:35',
  lab: 'Severstal Mill Lab - Impact Bay',
  technician: 'N. Orlov',
  spec: 'API 5L Sec. 9.8 / ASTM E23',
  sourceFile: 'CVN-lot238.pdf',
  testTempC: -10,
  requirements: { avgEnergyJ: 60, singleEnergyJ: 45, shearPct: 75 },
  sets: [
    {
      id: 'CVN-BODY',
      location: 'pipe_body',
      specimens: [
        { id: 'B1', energy: 88, shear: 92, lateralExpansion: 1.18, status: 'PASS' },
        { id: 'B2', energy: 94, shear: 95, lateralExpansion: 1.24, status: 'PASS' },
        { id: 'B3', energy: 91, shear: 94, lateralExpansion: 1.21, status: 'PASS' },
      ],
    },
    {
      id: 'CVN-WELD',
      location: 'weld_seam',
      specimens: [
        { id: 'W1', energy: 76, shear: 84, lateralExpansion: 1.03, status: 'PASS' },
        { id: 'W2', energy: 72, shear: 82, lateralExpansion: 0.98, status: 'PASS' },
        { id: 'W3', energy: 79, shear: 86, lateralExpansion: 1.07, status: 'PASS' },
      ],
    },
    {
      id: 'CVN-HAZ',
      location: 'haz',
      specimens: [
        { id: 'H1', energy: 68, shear: 80, lateralExpansion: 0.93, status: 'PASS' },
        { id: 'H2', energy: 71, shear: 82, lateralExpansion: 0.96, status: 'PASS' },
        { id: 'H3', energy: 66, shear: 78, lateralExpansion: 0.91, status: 'PASS' },
      ],
    },
  ],
};

export const BEND_DETAIL = {
  reportId: 'RPT-BEND-2024-11-LOT238',
  performedAt: '2024-11-14 17:05',
  lab: 'Severstal Mill Lab - Mechanical Bay',
  technician: 'K. Volkov',
  spec: 'API 5L Sec. 9.3 / ISO 5173',
  sourceFile: 'bend-results-2024-11-14.pdf',
  requirements: {
    bendAngleDeg: 180,
    maxOpenDefectMm: 3.0,
    mandrelDiameterT: 4,
  },
  specimens: [
    { id: 'FB-1', type: 'face_bend', rootOrFace: 'face', surface: 'weld face', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.0, status: 'PASS' },
    { id: 'FB-2', type: 'face_bend', rootOrFace: 'face', surface: 'weld face', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.2, status: 'PASS' },
    { id: 'FB-3', type: 'face_bend', rootOrFace: 'face', surface: 'weld face', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.0, status: 'PASS' },
    { id: 'FB-4', type: 'face_bend', rootOrFace: 'face', surface: 'weld face', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.4, status: 'PASS' },
    { id: 'RB-1', type: 'root_bend', rootOrFace: 'root', surface: 'weld root', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.0, status: 'PASS' },
    { id: 'RB-2', type: 'root_bend', rootOrFace: 'root', surface: 'weld root', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.1, status: 'PASS' },
    { id: 'RB-3', type: 'root_bend', rootOrFace: 'root', surface: 'weld root', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.0, status: 'PASS' },
    { id: 'RB-4', type: 'root_bend', rootOrFace: 'root', surface: 'weld root', angleDeg: 180, mandrelDiameterT: 4, maxOpenDefectMm: 0.3, status: 'PASS' },
  ],
};

export const HARDNESS_DETAIL = {
  reportId: 'RPT-HARD-2024-11-LOT238',
  performedAt: '2024-11-14 17:40',
  lab: 'Severstal Mill Lab - Mechanical Bay',
  technician: 'N. Orlov',
  spec: 'API 5L Annex H / ISO 6507-1',
  sourceFile: 'hardness-map-2024-11-14.pdf',
  method: 'HV10',
  requirements: {
    sourService: true,
    overallMaxHv10: 220,
    standardMaxHv10: 250,
  },
  locations: [
    {
      id: 'HB-BODY',
      location: 'pipe_body',
      readings: [
        { id: 'B1', position: 'body 3 o clock', valueHv10: 179, status: 'PASS' },
        { id: 'B2', position: 'body 6 o clock', valueHv10: 188, status: 'PASS' },
        { id: 'B3', position: 'body 9 o clock', valueHv10: 196, status: 'PASS' },
      ],
    },
    {
      id: 'HB-WELD',
      location: 'weld_seam',
      readings: [
        { id: 'W1', position: 'weld cap', valueHv10: 218, status: 'PASS' },
        { id: 'W2', position: 'weld root', valueHv10: 224, status: 'PENDING_REVIEW' },
        { id: 'W3', position: 'weld mid-wall', valueHv10: 238, status: 'PENDING_REVIEW' },
      ],
    },
    {
      id: 'HB-HAZ',
      location: 'haz',
      readings: [
        { id: 'H1', position: 'HAZ left', valueHv10: 229, status: 'PENDING_REVIEW' },
        { id: 'H2', position: 'HAZ right', valueHv10: 216, status: 'PASS' },
        { id: 'H3', position: 'HAZ toe', valueHv10: 221, status: 'PENDING_REVIEW' },
      ],
    },
  ],
};

export const AUT_DETAIL = {
  reportId: 'RPT-AUT-2024-11-LOT238',
  performedAt: '2024-11-14 18:10',
  station: 'AUT Station 4',
  operator: 'M. Petrov',
  spec: 'API 5L Annex E / DNV-ST-F101',
  sourceFile: 'aut-weld-scan-2024-11-14.pdf',
  acceptanceLevel: 'N2',
  calibration: {
    block: 'CRC-AUT-BLK-12',
    referenceReflector: '3.0 mm SDH',
    sensitivityDb: 6,
    lastVerified: '2024-11-14 08:15',
    status: 'PASS',
  },
  limits: {
    maxDepthPct: 8,
    maxLengthMm: 25,
    maxAmplitudePct: 60,
  },
  coverage: [
    { channel: 'CH-01', zone: 'weld cap', coveragePct: 100, status: 'PASS' },
    { channel: 'CH-02', zone: 'weld root', coveragePct: 100, status: 'PASS' },
    { channel: 'CH-03', zone: 'HAZ left/right', coveragePct: 100, status: 'PASS' },
  ],
  indications: [
    { id: 'IND-01', flawType: 'porosity', posMm: 2440, clock: '3:00', depthPct: 4.2, lengthMm: 12, amplitudePct: 42, status: 'PASS' },
    { id: 'IND-02', flawType: 'slag line', posMm: 6090, clock: '9:30', depthPct: 5.8, lengthMm: 18, amplitudePct: 48, status: 'PASS' },
  ],
};

export const DIMENSIONAL_DETAIL = {
  reportId: 'RPT-DIM-2024-11-PIPE9904',
  performedAt: '2024-11-14 09:15',
  station: 'Dimensional Bench 2',
  inspector: 'A. Morozov',
  spec: 'API 5L Sec. 9.11 / Project ITP',
  sourceFile: 'dimensional-checks-R9904.pdf',
  checks: [
    { key: 'OD', label: 'Outside diameter', location: 'pipe body', value: 660.6, unit: 'mm', min: 658.8, max: 662.0, status: 'PASS' },
    { key: 'WT', label: 'Wall thickness', location: 'min scan', value: 22.4, unit: 'mm', min: 21.5, max: 23.1, status: 'PASS' },
    { key: 'LEN', label: 'Pipe length', location: 'end-to-end', value: 12.18, unit: 'm', min: 12.0, max: 12.4, status: 'PASS' },
    { key: 'OVAL', label: 'Ovality', location: 'pipe body', value: 0.42, unit: '%', max: 1.0, status: 'PASS' },
    { key: 'STR', label: 'Straightness', location: 'full pipe', value: 1.8, unit: 'mm/m', max: 3.0, status: 'PASS' },
    { key: 'BEV', label: 'Bevel angle', location: 'end prep', value: 30.2, unit: 'deg', min: 29.5, max: 30.5, status: 'PASS' },
  ],
};

export const FLATTENING_DETAIL = {
  reportId: 'RPT-FLAT-2024-11-LOT238',
  performedAt: '2024-11-14 18:45',
  lab: 'Severstal Mill Lab - Mechanical Bay',
  technician: 'K. Volkov',
  spec: 'API 5L Sec. 9.3 / ISO 8492',
  sourceFile: 'flattening-results-2024-11-14.pdf',
  requirements: {
    position1DistanceHMm: 410,
    position2DistanceHMm: 235,
    crackMaxMm: 0,
    laminationAllowed: false,
  },
  specimens: [
    { id: 'FL-1', orientation: 'weld_0_deg', position: 'first close', surface: 'weld at 0 deg', hMm: 410.0, crackMm: 0.0, lamination: false, status: 'PASS' },
    { id: 'FL-2', orientation: 'weld_90_deg', position: 'first close', surface: 'weld at 90 deg', hMm: 408.5, crackMm: 0.0, lamination: false, status: 'PASS' },
    { id: 'FL-3', orientation: 'weld_0_deg', position: 'final close', surface: 'weld at 0 deg', hMm: 235.0, crackMm: 0.0, lamination: false, status: 'PASS' },
    { id: 'FL-4', orientation: 'weld_90_deg', position: 'final close', surface: 'weld at 90 deg', hMm: 236.2, crackMm: 0.0, lamination: false, status: 'PASS' },
  ],
};

export const HYDROSTATIC_DETAIL = {
  reportId: 'RPT-HYDRO-2024-11-PIPE9904',
  performedAt: '2024-11-14 11:20',
  station: 'Hydro Bay 1',
  operator: 'I. Smirnov',
  spec: 'API 5L Sec. 9.4 / Project ITP',
  sourceFile: 'hydrostatic-pressure-hold-R9904.pdf',
  testMedium: 'treated water',
  requirements: {
    minPressureMpa: 18.6,
    holdDurationS: 30,
    maxPressureDropMpa: 0.2,
    leakageAllowed: false,
  },
  readings: [
    { phase: 'Fill / vent', timeS: 0, pressureMpa: 0.4, status: 'PASS' },
    { phase: 'Ramp up', timeS: 18, pressureMpa: 12.5, status: 'PASS' },
    { phase: 'Peak pressure', timeS: 32, pressureMpa: 19.2, status: 'PASS' },
    { phase: 'Hold start', timeS: 35, pressureMpa: 19.1, status: 'PASS' },
    { phase: 'Hold end', timeS: 65, pressureMpa: 19.0, status: 'PASS' },
    { phase: 'Depressurize', timeS: 90, pressureMpa: 0.0, status: 'PASS' },
  ],
  checks: [
    { key: 'TEST_PRESSURE', label: 'Test pressure', value: 19.2, unit: 'MPa', min: 18.6, status: 'PASS' },
    { key: 'HOLD_TIME', label: 'Hold duration', value: 30, unit: 's', min: 30, status: 'PASS' },
    { key: 'PRESSURE_DROP', label: 'Pressure drop during hold', value: 0.1, unit: 'MPa', max: 0.2, status: 'PASS' },
    { key: 'LEAKAGE', label: 'Leakage events', value: 0, unit: 'events', max: 0, status: 'PASS' },
  ],
};

export const STANDARD_REPORT_DETAILS: Partial<Record<FullReportType, StandardReportDetailData>> = {
  VISUAL: {
    reportId: 'RPT-VIS-2024-11-1187',
    title: 'Visual',
    subtitle: 'external / internal visual inspection',
    status: 'PASS',
    performedAt: '2024-11-15 09:10',
    owner: 'QA Inspector L. Moroz',
    station: 'Final Inspection Line',
    source: 'MANUAL',
    sourceFile: 'visual-inspection-30858.pdf',
    spec: 'API 5L Sec. 9.10 / ITP 8',
    summary: 'No dents, arc burns, laminations, bevel damage, or marking defects observed.',
    checks: [
      { key: 'SURFACE', label: 'External surface condition', value: 0, unit: 'defects', max: 0, status: 'PASS' },
      { key: 'ENDS', label: 'End face / bevel condition', value: 0, unit: 'defects', max: 0, status: 'PASS' },
      { key: 'MARKING', label: 'Stencil and traceability marking', value: 1, unit: 'verified', min: 1, status: 'PASS' },
      { key: 'CLEANLINESS', label: 'Internal cleanliness', value: 1, unit: 'verified', min: 1, status: 'PASS' },
    ],
    observations: [
      { id: 'VIS-1', area: 'Body', finding: 'No surface discontinuities', disposition: 'Accept', status: 'PASS' },
      { id: 'VIS-2', area: 'Bevel end 1', finding: 'Bevel clean, no handling damage', disposition: 'Accept', status: 'PASS' },
      { id: 'VIS-3', area: 'Marking', finding: 'Pipe number, heat, grade readable', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['Surface defects', '0 rejectable'], ['Traceability marking', 'required'], ['End preparation', 'no visible damage']],
  },
  RT: {
    reportId: 'RPT-RT-2024-11-1187',
    title: 'Radiographic',
    subtitle: 'weld seam radiography',
    status: 'PASS',
    performedAt: '2024-11-14 18:25',
    owner: 'RT Level II A. Belov',
    station: 'RT Bunker 3',
    source: 'PDF_DIGITAL',
    sourceFile: 'RT-30858-weld.pdf',
    spec: 'API 5L Annex E / ISO 10893-6',
    summary: 'Radiographic shots accepted. No rejectable lack of fusion, cracks, or clustered porosity.',
    checks: [
      { key: 'SENSITIVITY', label: 'Image quality sensitivity', value: 1.6, unit: '%', max: 2.0, status: 'PASS' },
      { key: 'DENSITY', label: 'Film density', value: 2.8, unit: 'D', min: 2.0, max: 4.0, status: 'PASS' },
      { key: 'REJECTS', label: 'Rejectable indications', value: 0, unit: 'count', max: 0, status: 'PASS' },
    ],
    observations: [
      { id: 'RT-01', area: 'Weld 0-120 deg', finding: 'No relevant indication', disposition: 'Accept', status: 'PASS' },
      { id: 'RT-02', area: 'Weld 120-240 deg', finding: 'Isolated pore below limit', disposition: 'Accept', status: 'PASS' },
      { id: 'RT-03', area: 'Weld 240-360 deg', finding: 'No relevant indication', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['IQI sensitivity', '<= 2.0 %'], ['Film density', '2.0-4.0 D'], ['Rejectable indications', '0']],
  },
  MPT: {
    reportId: 'RPT-MPT-2024-11-1187',
    title: 'Magnetic Particle',
    subtitle: 'surface crack detection',
    status: 'PASS',
    performedAt: '2024-11-15 08:40',
    owner: 'NDT Level II S. Antonov',
    station: 'MPI Bench 1',
    source: 'PDF_DIGITAL',
    sourceFile: 'MPT-30858.pdf',
    spec: 'ISO 10893-5 / ASTM E709',
    summary: 'Magnetic particle examination found no relevant linear indications.',
    checks: [
      { key: 'FIELD', label: 'Magnetic field strength', value: 3.2, unit: 'kA/m', min: 2.4, max: 4.0, status: 'PASS' },
      { key: 'LIFT', label: 'Yoke lift test', value: 4.6, unit: 'kg', min: 4.5, status: 'PASS' },
      { key: 'INDICATIONS', label: 'Relevant indications', value: 0, unit: 'count', max: 0, status: 'PASS' },
    ],
    observations: [
      { id: 'MPT-1', area: 'Weld cap', finding: 'No linear indication', disposition: 'Accept', status: 'PASS' },
      { id: 'MPT-2', area: 'HAZ left', finding: 'No relevant indication', disposition: 'Accept', status: 'PASS' },
      { id: 'MPT-3', area: 'HAZ right', finding: 'No relevant indication', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['Linear indications', '0 rejectable'], ['Yoke lift', '>= 4.5 kg'], ['Field strength', '2.4-4.0 kA/m']],
  },
  HEAT_TREAT: {
    reportId: 'RPT-HT-2024-11-FB014',
    title: 'Heat Treatment',
    subtitle: 'furnace batch cycle verification',
    status: 'PASS',
    performedAt: '2024-11-13 23:30',
    owner: 'Furnace Operator V. Smirnov',
    station: 'Furnace FB-014',
    source: 'API_FEED',
    sourceFile: 'heat-treatment-FB014.json',
    spec: 'ITP 5 / TMCP route card',
    summary: 'Furnace batch FB-014 completed within qualified thermal cycle window.',
    checks: [
      { key: 'SOAK_TEMP', label: 'Soak temperature', value: 612, unit: 'C', min: 600, max: 625, status: 'PASS' },
      { key: 'SOAK_TIME', label: 'Soak duration', value: 42, unit: 'min', min: 35, max: 55, status: 'PASS' },
      { key: 'COOL_RATE', label: 'Cooling rate', value: 18, unit: 'C/min', min: 12, max: 25, status: 'PASS' },
    ],
    observations: [
      { id: 'HT-1', area: 'Zone 1', finding: 'Within thermal envelope', disposition: 'Accept', status: 'PASS' },
      { id: 'HT-2', area: 'Zone 2', finding: 'Within thermal envelope', disposition: 'Accept', status: 'PASS' },
      { id: 'HT-3', area: 'Quench exit', finding: 'Cooling rate in range', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['Soak temperature', '600-625 C'], ['Soak duration', '35-55 min'], ['Cooling rate', '12-25 C/min']],
  },
  PIPE_BODY_UT: {
    reportId: 'RPT-PBUT-2024-11-1187',
    title: 'Pipe Body UT',
    subtitle: 'lamination and body wall ultrasonic scan',
    status: 'PASS',
    performedAt: '2024-11-14 12:55',
    owner: 'UT Level II P. Fedorov',
    station: 'Body UT Line 1',
    source: 'API_FEED',
    sourceFile: 'pipe-body-ut-2024-11-14.csv',
    spec: 'API 5L PSL2 / ISO 10893-8',
    summary: '100% body UT completed. No lamination indications above U2 acceptance level.',
    checks: [
      { key: 'COVERAGE', label: 'Scan coverage', value: 100, unit: '%', min: 100, status: 'PASS' },
      { key: 'MIN_WT', label: 'Minimum verified wall', value: 22.1, unit: 'mm', min: 21.5, status: 'PASS' },
      { key: 'REJECTS', label: 'Rejectable laminations', value: 0, unit: 'count', max: 0, status: 'PASS' },
    ],
    observations: [
      { id: 'PBUT-1', area: 'Body strip A', finding: 'No relevant lamination', disposition: 'Accept', status: 'PASS' },
      { id: 'PBUT-2', area: 'Body strip B', finding: 'No relevant lamination', disposition: 'Accept', status: 'PASS' },
      { id: 'PBUT-3', area: 'End zones', finding: 'Coverage complete', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['Acceptance level', 'U2'], ['Coverage', '100 %'], ['Rejectable laminations', '0']],
  },
  MFL_ET: {
    reportId: 'RPT-MFLET-2024-11-1187',
    title: 'MFL / ET',
    subtitle: 'flux leakage / eddy-current applicability record',
    status: 'INCOMPLETE',
    performedAt: 'not scheduled',
    owner: 'NDT Planning',
    station: 'N/A for SAWL route',
    source: 'MANUAL',
    sourceFile: 'route-applicability-30858.json',
    spec: 'ITP applicability matrix',
    summary: 'MFL / ET is configured for ERW route only. Current pipe type is SAWL, so this report is not applicable.',
    checks: [
      { key: 'APPLIES', label: 'Applies to pipe route', value: 0, unit: 'flag', max: 0, status: 'INCOMPLETE' },
      { key: 'ROUTE', label: 'Pipe route SAWL', value: 1, unit: 'verified', min: 1, status: 'PASS' },
    ],
    observations: [
      { id: 'MFL-NA', area: 'Route matrix', finding: 'SAWL pipe does not require MFL / ET', disposition: 'N/A', status: 'INCOMPLETE' },
    ],
    limits: [['Applicability', 'ERW only'], ['Current route', 'SAWL'], ['Clearance impact', 'not required']],
  },
  COATING: {
    reportId: 'RPT-COAT-2024-11-1187',
    title: 'Coating',
    subtitle: 'downstream coating transfer placeholder',
    status: 'INCOMPLETE',
    performedAt: 'awaiting coating plant',
    owner: 'Coating Plant Interface',
    station: 'External applicator',
    source: 'MANUAL',
    sourceFile: 'coating-transfer-pending.json',
    spec: 'ITP 11.1 / project coating spec',
    summary: 'Coating record is expected from downstream applicator. Current pipe is blocked until transfer arrives.',
    checks: [
      { key: 'TRANSFER', label: 'Coating record received', value: 0, unit: 'flag', min: 1, status: 'INCOMPLETE' },
      { key: 'DFT_MIN', label: 'Minimum DFT', value: 0, unit: 'um', min: 450, status: 'INCOMPLETE' },
      { key: 'HOLIDAY', label: 'Holiday test defects', value: 0, unit: 'count', max: 0, status: 'INCOMPLETE' },
    ],
    observations: [
      { id: 'COAT-1', area: 'Applicator transfer', finding: 'Record not yet received', disposition: 'Awaiting transfer', status: 'INCOMPLETE' },
    ],
    limits: [['Minimum DFT', '>= 450 um'], ['Holiday defects', '0'], ['Record source', 'coating plant']],
  },
  THREAD: {
    reportId: 'RPT-THD-2024-11-1187',
    title: 'Threads',
    subtitle: 'end connection applicability record',
    status: 'INCOMPLETE',
    performedAt: 'not scheduled',
    owner: 'Finishing Planning',
    station: 'N/A for bevelled-end SAWL',
    source: 'MANUAL',
    sourceFile: 'thread-applicability-30858.json',
    spec: 'ITP end finish matrix',
    summary: 'Thread inspection is not applicable because this project uses bevelled-end SAWL line pipe.',
    checks: [
      { key: 'END_TYPE', label: 'Bevelled end selected', value: 1, unit: 'verified', min: 1, status: 'PASS' },
      { key: 'THREAD_REQ', label: 'Threading required', value: 0, unit: 'flag', max: 0, status: 'INCOMPLETE' },
    ],
    observations: [
      { id: 'THD-NA', area: 'End finish', finding: 'No threaded connection required', disposition: 'N/A', status: 'INCOMPLETE' },
    ],
    limits: [['Project end type', 'bevelled'], ['Thread inspection', 'not applicable'], ['Clearance impact', 'not required']],
  },
  WELD_MAP: {
    reportId: 'RPT-WMAP-2024-11-1187',
    title: 'Weld Map',
    subtitle: 'weld seam traceability and repair map',
    status: 'PASS',
    performedAt: '2024-11-14 09:20',
    owner: 'Weld Data System',
    station: 'SAWL Line 2',
    source: 'API_FEED',
    sourceFile: 'weld-map-30858.json',
    spec: 'ITP 6.2 / weld traceability procedure',
    summary: 'Weld seam, coil/plate traceability, WPS, and repair status linked for this pipe.',
    checks: [
      { key: 'WPS', label: 'Approved WPS linked', value: 1, unit: 'verified', min: 1, status: 'PASS' },
      { key: 'SEAM_LEN', label: 'Mapped weld length', value: 12.18, unit: 'm', min: 12.0, status: 'PASS' },
      { key: 'REPAIRS', label: 'Open weld repairs', value: 0, unit: 'count', max: 0, status: 'PASS' },
      { key: 'TRACE', label: 'Plate-to-pipe trace link', value: 1, unit: 'verified', min: 1, status: 'PASS' },
    ],
    observations: [
      { id: 'WM-1', area: 'Longitudinal seam', finding: 'WPS-SAWL-X65-22 linked', disposition: 'Accept', status: 'PASS' },
      { id: 'WM-2', area: 'Repair register', finding: 'No open repairs', disposition: 'Accept', status: 'PASS' },
      { id: 'WM-3', area: 'Traceability', finding: 'Plate P-5272-44 linked to pipe', disposition: 'Accept', status: 'PASS' },
    ],
    limits: [['Approved WPS', 'required'], ['Open repairs', '0'], ['Traceability link', 'required']],
  },
};
